import { useEffect } from "react";
import DatabaseBanner from "../HomePage/Technology/AllBanner/DatabaseBanner";
import DbMain from "./TechnologiesDbPage/DbMain";
import FooterContact from "../FooterContactPage/FooterContact";
import { Helmet } from "react-helmet-async";

const TechDb = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Helmet>
        <title>
          Database Technologies and Architecture | Quad Theory Ltd
        </title>
        <meta
          name="description"
          content="Explore how Quad Theory Ltd designs practical database architectures using MySQL, PostgreSQL, MongoDB, Redis, SQL Server, and SQLite."
        />
      </Helmet>
      <DatabaseBanner />
      <DbMain />
      {/* form component yeameen */}
      <FooterContact />
    </div>
  );
};

export default TechDb;
